import { render, staticRenderFns } from "./LimitsCard.vue?vue&type=template&id=3a5fb390&scoped=true&"
import script from "./LimitsCard.vue?vue&type=script&lang=ts&"
export * from "./LimitsCard.vue?vue&type=script&lang=ts&"
import style0 from "./LimitsCard.vue?vue&type=style&index=0&id=3a5fb390&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a5fb390",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText,VCardTitle})
